/**
 * Корневые routes для cabinet-сборки. Выбор cabinet vs showcase делается
 * runtime'ом по `window.location.host === environment.showcaseUrl`
 * (с учётом порта — см. `resolveIsShowcase`), чтобы локально `ng serve` на
 * `localhost:4401` без отдельной сборки уже отдавал витрину.
 *
 * SSR-fallback — cabinet (`typeof window === 'undefined'`), потому что
 * SSR-рендер делается на cabinet-домене и витрина CSR-only.
 *
 * Showcase-сборка (`ng build --configuration=nextshowcase`) подменяет этот
 * файл на `app.routes.showcase.ts` через fileReplacement в angular.json,
 * там cabinet routes физически не попадают в bundle.
 */
import {Routes} from '@angular/router';
import {environment} from '../environments/environment';
import {routes as cabinetRoutes} from './cabinet/cabinet.routes';
import {showCaseRoutes} from './cabinet/showcase.routing.module';
import {resolveIsShowcase} from './cabinet/shared/tokens/is-showcase.factory';

const isShowcase =
  typeof window !== 'undefined'
  && resolveIsShowcase(window.location.host, environment.showcaseUrl);

export const routes: Routes = isShowcase ? showCaseRoutes : cabinetRoutes;
